package com.merkost.handpass.api.dto.review

import com.merkost.handpass.api.dto.user.ProfileResponse
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class ReviewResponse(
    val id: String,
    @SerialName("deal_id") val dealId: String,
    @SerialName("listing_id") val listingId: String,
    @SerialName("reviewer_id") val reviewerId: String,
    @SerialName("reviewee_id") val revieweeId: String,
    val rating: Int,
    val comment: String? = null,
    @SerialName("is_seller_review") val isSellerReview: Boolean,
    @SerialName("created_at") val createdAt: String,
    val reviewer: ProfileResponse? = null,
    val reviewee: ProfileResponse? = null,
    @SerialName("listing_title") val listingTitle: String? = null,
    @SerialName("listing_image") val listingImage: String? = null
)
